import icon from "../../assets/power-backup.svg";
import type { Property } from "../../types";

export const generalRedundancy: Property = {
  id: "generalRedundancy",
  title: "generalRedundancy.title",
  // todo add didzis about this icon as well for use with shadow mode
  icon,
};
